// The server remains authoritative. These helpers prevent the UI from promoting
// missing or stale validation to a completed document.
export function documentationStatus(status, validation) {
  if (status === "truncated" || status === "cancelled") return status;
  return status === "complete" && validation?.ok === true ? "complete" : "draft";
}

export function documentationStreamEvent(state, event) {
  return {
    markdown: typeof event.docReplace === "string" ? event.docReplace
      : state.markdown + (typeof event.text === "string" ? event.text : ""),
    validation: event.validation || state.validation || null,
    limited: state.limited || !!event.tokenLimit,
    publicationPending: state.publicationPending || !!event.documentationSaved?.publicationPending || event.documentationSaved?.status === "draft",
  };
}

export function documentationStreamStatus(state) {
  return documentationStatus(state.limited ? "truncated" : state.publicationPending ? "draft" : "complete", state.validation);
}
